import React, { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { Center, Spinner, useToast } from "@chakra-ui/react";
import { useAuth } from "../../contexts/AuthContext";

// Gates admin-only dashboard pages. Admin status can come from the dynamic
// profiles.is_admin flag, which loads asynchronously, so we wait for the
// profile before deciding — otherwise a dynamic admin would be bounced on the
// first render before their profile arrives.
const AdminRoute = ({ children, redirectTo = "/dashboard" }) => {
  const toast = useToast();
  const { isAdmin, loading, session, profileLoading } = useAuth();
  const resolving = loading || (session && profileLoading);
  const notifiedRef = useRef(false);

  useEffect(() => {
    if (!resolving && !isAdmin && !notifiedRef.current) {
      notifiedRef.current = true;
      toast({
        title: "Admins only",
        description: "You do not have permission to view that page.",
        status: "warning",
        duration: 4000,
        isClosable: true,
        position: "top",
      });
    }
  }, [resolving, isAdmin, toast]);

  if (resolving) {
    return (
      <Center minH="60vh">
        <Spinner size="lg" thickness="3px" color="blue.500" />
      </Center>
    );
  }

  if (!isAdmin) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default AdminRoute;
